export default function authHeader() {
  // return authorization header with jwt token
  const user = JSON.parse(localStorage.getItem('user'));

  if (user && user.token) {
    return { Authorization: `Bearer ${user.token}` };
  }
  return {};
}

export function authHeader2() {
  const accessType = localStorage.getItem('token_type');
  const accessToken = localStorage.getItem('access_token');
  return {
    'Content-Type': 'application/json',
    Authorization: `${accessType} ${accessToken}`,
  };
}

export function authHeaderFormData() {
  const accessType = localStorage.getItem('token_type');
  const accessToken = localStorage.getItem('access_token');
  return {
    'Content-Type': 'application/json',
    Authorization: `${accessType} ${accessToken}`,
  };
}



// WEBPACK FOOTER //
// ./src/helper/authHeader.js